import { GridItem, GridItemProps as ChakraUIGridProps } from "@chakra-ui/react";

import { GridLayout } from "../grid-layout/grid-layout";

export type GridItemProps = Pick<
  ChakraUIGridProps,
  "colStart" | "colSpan" | "padding" | "children" | "maxWidth"
>;
export function SingleColumnLayout({
  children,
  colStart = { base: 1, lg: 4, xl: 5 },
  colSpan = { base: 4, lg: 6, xl: 4 },
  padding = { sm: "40px 0", xl: "2.5rem", "2xl": "7.5rem" },
  maxWidth = "100%"
}: GridItemProps): JSX.Element {
  return (
    <GridLayout>
      <GridItem
        colStart={colStart}
        colSpan={colSpan}
        padding={padding}
        maxW={maxWidth}
      >
        {children}
      </GridItem>
    </GridLayout>
  );
}
